export default function Process() {
  const steps = [
    {
      number: 1,
      title: "Requirement Analysis",
      desc: "Understand your business goals, audience, and project requirements.",
    },
    {
      number: 2,
      title: "Solution Proposal",
      desc: "Define project scope, recommended solution, and cost estimate.",
    },
    {
      number: 3,
      title: "UI & Scope Approval",
      desc: "Review workflows, layouts, and finalize project specifications.",
    },
    {
      number: 4,
      title: "Development & Reviews",
      desc: "Build the solution with periodic demonstrations and feedback.",
    },
    {
      number: 5,
      title: "Testing & Launch",
      desc: "Validate, deploy, and provide guidance for a smooth handover.",
    },
  ];

  return (
    <section className="process" id="process">
      <div className="container">
        <div className="section-title">
          <h2>Our Project Execution Process</h2>
          <p>
            A transparent and structured approach designed to deliver
            reliable digital solutions.
          </p>
        </div>

        <div className="process-steps">
          {steps.map((step) => (
            <div className="step" key={step.number}>
              <div className="step-icon">{step.number}</div>

              <h3>{step.title}</h3>

              <p>{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="process-footer">
          <p>
            Every project is executed through clearly defined milestones,
            regular reviews, and collaborative feedback to ensure successful
            delivery.
          </p>
        </div>

          {/* Important Note */}
        <div className="process-note">
        <p>
            <strong>Important:</strong><p> Project pricing, timelines, and
            deliverables are finalized after requirement analysis. Features
            requested after scope approval may require additional cost and
            timeline adjustments. </p> <p>Third-party services such as hosting,
            domains, APIs, SMS gateways, and premium subscriptions are
            chargeable separately unless specifically included.</p>
        </p>
        </div>


      </div>
    </section>
  );
}